module.exports = __webpack_public_path__ + "img/Trust.3e5b2d9.svg";